import axios from 'axios';

// Create axios instance with base URL
const axiosInstance = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
  withCredentials: true,
  timeout: 60000, // 60 seconds for file uploads
  headers: {
    'Content-Type': 'application/json'
  }
});

// Add request interceptor for authentication and debugging
axiosInstance.interceptors.request.use(
  (config) => {
    // Add JWT token from localStorage if available
    // Try multiple token keys for compatibility
    const token = localStorage.getItem('accessToken') ||
                  localStorage.getItem('cms_accessToken') ||
                  localStorage.getItem('cmsToken');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }

    console.log('[AXIOS] Request:', config.method?.toUpperCase(), config.url);
    console.log('[AXIOS] Headers:', config.headers);
    return config;
  },
  (error) => {
    console.error('[AXIOS] Request error:', error);
    return Promise.reject(error);
  }
);

// Add response interceptor for debugging
axiosInstance.interceptors.response.use(
  (response) => {
    console.log('[AXIOS] Response:', response.status, response.statusText);
    return response;
  },
  (error) => {
    console.error('[AXIOS] Response error:', error.response?.status, error.message);
    return Promise.reject(error);
  }
);

export default axiosInstance;
